import React from 'react';
import LauncherAppIcon from './LauncherAppIcon';

// Shared geometry and typography use the launcher styles in ServiceMenuPage.css.
export default function LauncherServiceCard({ service, description, openingId, failedId, isFavorite, canSave, favoriteLimitId, onOpen, onFavorite }) {
    return (
      <div key={service.id} className="launcher-app" data-service-id={service.id}>
        <button type="button" className="launcher-open" disabled={openingId !== null} aria-busy={openingId === service.id} data-failed={failedId === service.id} onClick={() => onOpen(service)}>
          <span className="launcher-artwork" aria-hidden="true"><img src={service.iconImage} alt="" draggable="false" /></span>
          <span className="launcher-title-row"><LauncherAppIcon id={service.id} /><span className="launcher-app-name">{service.title}</span></span>
          <span className="launcher-app-description">{description}</span>
          {openingId === service.id && <span className="launcher-action-state" role="status">여는 중…</span>}
          {failedId === service.id && <span className="launcher-action-error" role="alert">화면을 열지 못했습니다. 다시 시도</span>}
        </button>
        <button type="button" className="launcher-star" aria-label={`${service.title} 즐겨찾기 ${isFavorite ? '해제' : '추가'}`} aria-pressed={isFavorite} disabled={!canSave} onClick={() => onFavorite(service.id)}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><g transform="rotate(35 12 12)"><path d="M8 3h8v2l-2 1v4l3 3v2H7v-2l3-3V6L8 5Z" /><path d="M12 15v6" fill="none" /></g></svg>
        </button>
        {favoriteLimitId === service.id && <span className="launcher-favorite-limit" role="status">최대 4개까지입니다</span>}
      </div>
    );
}
